import React from "react";
import LightGallery from "lightgallery/react";

// import styles
import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-zoom.css";
import "lightgallery/css/lg-thumbnail.css";
// import plugins if you need
import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgZoom from "lightgallery/plugins/zoom";

function Table(props) {
  const onInit = () => {
    console.log("lightGallery has been initialized");
  };
  return (
    <>
      <tbody>
        <tr>
          <th scope="row">
            <LightGallery onInit={onInit} speed={500} plugins={[lgThumbnail]}>
              <img src={props.planImage} alt="" />
            </LightGallery>
          </th>
          {/* "https://mirabad.uz/upload/kelnik.estate/b51/b512bef2f489ba078a8028ab9e2440f8.svg" */}
          <td>
            {props.info}
            <br /> <br />{" "}
            <span className="badge bg-warning fs-6">
              {props.additionalInfo}
            </span>
          </td>
          <td>{props.size}</td>
          <td>{props.floor}</td>
          <td>{props.zdacha}</td>
          <td>
            <a href={props.moreLink}>Know more</a>
          </td>
        </tr>
      </tbody>
    </>
  );
}

export default Table;
